import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import Departments from './departments';
import {toJS} from "../hocs/toJs";
import {formValueSelector} from "redux-form/immutable";

const selector = formValueSelector('sortDepartmentsForm');

const parseDepartments = (department) => {
  const parsedDepartments = [];
  department.valueSeq().toArray().forEach( department => (
    parsedDepartments.push({
      id: department.get('id'),
      name: department.get('name'),
      weightOld: department.get('weightOld'),
      weightNew: department.get('weightNew'),
      weightNewComing: department.get('weightNewComing'),
      createdDate: department.get('createdDate'),
    })));
  return parsedDepartments;
};

class DepartmentsHOC extends Component {

  componentDidMount() {

    this.props.getDepartments({
      filter:{
        where: {or: [{deleted: false}, {deleted: null}]},
        include: 'criteria'
      }});

  }

  _getPendingStoresToScore = (department) => {
    return this.props.stores.filter(store => {
      if(store.old && !department.weightOld) { return false }

      if(store.newComing && !department.weightNewComing) { return false }

      if(store.new && !department.weightNew) { return false }

      if(!department.criteria) {
        return true;
      }

      const storePendingCriteria = this._getStorePendingCriteria(store, department);
      return storePendingCriteria.length
    });
  };

  _getStorePendingCriteria = (store, department) => {
    const scores = this.props.scoreRecords
      .filter(scoreRecord => {return department.id === scoreRecord.departmentId })
      .reduce((acc, current) => {
        return [...acc, ...current.scores]
      }, []);
    let storeScoredCriteria = scores.filter(score => {
      return score.storeId === store.id && score.scoreValue > 0
    }).map(score => score.criteriaId);
    let weightType = '';
    if(store.old) {
      weightType = 'weightOld'
    } else if(store.newComing) {
      weightType = 'weightNewComing'
    } else if(store.new) {
      weightType = 'weightNew'
    }

    return department.criteria.filter(criterion => {
      return criterion[weightType] > 0 && !storeScoredCriteria.includes(criterion.id)
    })
  };

  getTotalStoresThatCanBeScored = (department) => {
    return this.props.stores.reduce((acc, current) => {
      if(current.old && department.weightOld > 0) { return acc + 1 }

      if(current.newComing && department.weightNewComing > 0) { return acc + 1 }

      if(current.new && department.weightNew > 0) { return acc + 1 }

      return acc
    }, 0)
  };

  getDepartments = () => {
    return this.props.departments.map(department => {
      const pendingStoresToScore = this._getPendingStoresToScore(department);
      const totalStoresThatCanBeScored = this.getTotalStoresThatCanBeScored(department);
      return {
        ...department,
        totalScoredStores: totalStoresThatCanBeScored - pendingStoresToScore.length
      }
    })
  };

  render(){
    return (
      <Departments
        {...this.props}
        getTotalStoresThatCanBeScored={this.getTotalStoresThatCanBeScored}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    departments: state.departments.get('departments'),
    loading: state.departments.get('fetching'),
    departmentsErrors: state.departments.get('errors'),
    deletingDepartment: state.department.get('deleting'),
    scoreRecords: state.scoreRecords.get('scoreRecords'),
    fetchingScoreRecords: state.scoreRecords.get('fetching'),
    stores: state.stores.get('stores'),
    fetchingStores: state.stores.get('fetching'),
    mobileViewSortBy: selector(state, 'sortBy'),
    mobileViewSortOrder: selector(state, 'sortOrder'),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDepartments: (payload) => {
      dispatch(actions.getDepartments(payload))
    },
    changeDepartmentsState: (payload) => {
      dispatch(actions.changeDepartmentsState(payload))
    },
    getDepartmentsWithFilters: (payload) => {
      dispatch(actions.getDepartmentsWithFilters(payload))
    },
    deleteDepartment: (payload) => {
      dispatch(actions.deleteDepartment(payload))
    },
    getScoreRecords: (payload) => {
      dispatch(actions.getScoreRecords(payload))
    },
    getStores: (payload) => {
      dispatch(actions.getStores(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(DepartmentsHOC));



// WEBPACK FOOTER //
// ./src/components/departments/departmentsHOC.js